export default __webpack_public_path__ + "static/media/Belt of Black Whispers.32d4bc2e.jpg";